<template>
  <div class="heatmap" :style="{height:wapperHeight}">
    <div class="heatmap__title" flex="main:center cross:center">销售渠道</div>
    <ve-heatmap
      style="top:-40px"
      :height="height"
      :data="chartData"
      color="#fff"
      :visual-map="chartVisualMap"
      :grid="chartGrid"
      :textStyle="textStyle"
      :settings="chartSettings"
    ></ve-heatmap>
  </div>
</template>

<script>
import VeHeatmap from 'v-charts/lib/heatmap'

export default {
  components: { VeHeatmap },
  name: 'heatmapChart',
  data () {
    let clientHeight = document.body.clientHeight - 30
    function getValue (per) {
      return (per * clientHeight) / 100
    }
    this.chartSettings = {
      roseType: 'radius',
      // radius: getValue(5),
      // offsetY: getValue(0.5),
      label: {
        show: false
      }
      //  level: [
      //   ['1/1', '1/2', '1/3'],
      //   ['1/4', '1/5']
      // ]
    }

    this.chartGrid = {
      right: 90
    }
    this.chartVisualMap = {
      min: 0,
      max: 1500,
      type: 'piecewise',
      right: 0,
      top: '20%',
      textStyle: {
        color: '#fff',
        fontSize: 8
      }
    }

    return {
      wapperHeight: getValue(26) + 'px',
      width: getValue(23) + 'px',
      height: getValue(30) + 'px',
      textStyle: {
        color: '#fff',
        fontWeight: 'bold'
      },
      chartData: {
        columns: ['时间', '地点', '人数'],
        rows: [
          { 时间: '星期一', 地点: '北京', 人数: 1000 },
          { 时间: '星期二', 地点: '上海', 人数: 400 },
          { 时间: '星期三', 地点: '杭州', 人数: 800 },
          { 时间: '星期二', 地点: '深圳', 人数: 200 },
          { 时间: '星期三', 地点: '长春', 人数: 100 },
          { 时间: '星期五', 地点: '南京', 人数: 300 },
          { 时间: '星期四', 地点: '江苏', 人数: 800 },
          { 时间: '星期三', 地点: '北京', 人数: 700 },
          { 时间: '星期三', 地点: '上海', 人数: 200 },
          { 时间: '星期二', 地点: '杭州', 人数: 500 }
        ]
      }
    }
  },
  methods: {
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.heatmap {
  background-image: url("../../image/pie.png");
  background-size: 100% 100%;
  background-color: rgba(19, 54, 79, 0);
  color: #fff;
  width: 100%;
  height: 238px;
  touch-action: none;
  &__title {
    height: 0.5rem;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
